var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17188",
    transform: "translate(216.5 251)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1404",
    clipPath: "url(#a)",
    transform: "translate(-216.5 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17227",
    fill: "none",
    d: "M216.5 251h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21541",
    d: "M242.75 276H221.5v-11.125c1.25-3.187 2.063-5.125 3.75-5.125s3.063 3.063 4.188 5.813 2.875 6.688 5.813 6.688 5.5-4.25 6.813-7.937a1.25 1.25 0 0 0-.75-1.625 1.312 1.312 0 0 0-1.625.75c-.564 1.561-2.189 6.311-4.439 6.311-1.312 0-2.437-2.75-3.5-5.187-1.437-3.437-3.062-7.312-6.5-7.312a4.5 4.5 0 0 0-3.75 1.999v-4.5a1.25 1.25 0 0 0-2.5 0v23.75h23.75a1.25 1.25 0 0 0 0-2.5Z",
    fill: "#185edf"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21542",
    d: "M4.235 18.548s6.349 7.15 12.5-5.878a15.9 15.9 0 0 1 6.6-7.884",
    fill: "none",
    stroke: "#185edf",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartBlue);
export default __webpack_public_path__ + "static/media/line-chart-blue.73df703be9c4c19abcf7db4317e54511.svg";
export { ForwardRef as ReactComponent };